import Vue from 'vue';
import { mapGetters } from 'vuex';

/* eslint-disable no-unused-vars */
import accordionComponent from './accordion-component';
/* eslint-enable no-unused-vars */

Vue.component('faq-component', {
  template: `<div class="c-faq">
              <accordion-component v-bind:should-toggle="true" v-bind:acc-data="faqs"></accordion-component>
            </div>`,
  computed: {
    ...mapGetters({ faqs: 'getFAQs' }),
  },
});



// WEBPACK FOOTER //
// ./app/js/components/faq-component.js